import { createContext } from 'react';
import type { AgentProgress } from '@trinity/chat';

export const AgentProgressContext = createContext<AgentProgress | null>(null);

AgentProgressContext.displayName = 'AgentProgressContext';
